import axios from 'axios'

export const checkAuthStatus = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_FIREBASE_FUNCTION}/auth/status`,
      {},
      {
        withCredentials: true
      }
    )
    return res.data
  } catch (err) {
    console.error(err)
  }
}
